<div class="settings-mobile-list-controls d-flex flex-column gap-3">
    <div v-if="showSearch" class="input-group input-group-sm">
        <span class="input-group-text bg-dark text-white-50 border-secondary">
            <i class="bi bi-search"></i>
        </span>
        <input
            type="search"
            class="form-control bg-dark text-white border-secondary"
            :placeholder="searchPlaceholder"
            :value="searchValue"
            @input="$emit('update:search-value', $event.target.value)"
        />
    </div>

    <nav v-if="showPagination && pageCount > 1" :aria-label="paginationLabel">
        <ul class="pagination pagination-sm settings-mobile-pagination justify-content-center mb-0">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button class="page-link" type="button" @click="set_page(1)" aria-label="First page">
                    <i class="bi bi-chevron-double-left"></i>
                </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button class="page-link" type="button" @click="set_page(currentPage - 1)" aria-label="Previous page">
                    <i class="bi bi-chevron-left"></i>
                </button>
            </li>
            <li
                v-for="page in page_numbers"
                :key="page"
                class="page-item"
                :class="{ active: page === currentPage }"
            >
                <button class="page-link" type="button" @click="set_page(page)">{{ page }}</button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                <button class="page-link" type="button" @click="set_page(currentPage + 1)" aria-label="Next page">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                <button class="page-link" type="button" @click="set_page(pageCount)" aria-label="Last page">
                    <i class="bi bi-chevron-double-right"></i>
                </button>
            </li>
        </ul>
    </nav>
</div>
